import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API;

const ResponderCheckpoint = () => {
  const { id } = useParams();
  const [dados, setDados] = useState(null);
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [resposta, setResposta] = useState("");
  const [erro, setErro] = useState("");
  const [mensagem, setMensagem] = useState("");

  useEffect(() => {
    axios
      .get(`${API}/api/checkpoints_publicados/${id}`)
      .then((res) => {
        setDados(res.data);
        document.body.style.backgroundColor = res.data.cor_header || "#f0f0f0";
      })
      .catch(() => setErro("Erro ao carregar dados do checkpoint."));

    return () => {
      document.body.style.backgroundColor = "white";
    };
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nome || !email || !resposta) {
      setErro("Preencha todos os campos.");
      return;
    }

    axios
      .post(`${API}/api/respostas`, {
        checkpoint_publicado_id: id,
        nome,
        email,
        resposta,
      })
      .then(() => {
        setMensagem("Resposta enviada com sucesso!");
        setErro("");
      })
      .catch(() => setErro("Erro ao enviar resposta."));
  };

  if (erro) return <p className="text-danger">{erro}</p>;
  if (!dados) return <p>Carregando...</p>;

  const {
    nome_turma,
    nome_disciplina,
    nome_sessao,
    nome_curso,
    nome_professor,
    texto_checkpoint,
    tempo_resposta,
    logo_cliente
  } = dados;

  return (
    <div style={{ minHeight: "100vh", padding: "20px" }}>
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        maxWidth: "600px",
        marginInline: "auto"
      }}>
        {logo_cliente && (
          <img
            src={logo_cliente}
            alt="Logo do Cliente"
            style={{
              height: "auto",
              width: "100%",
              maxWidth: "45%",
              objectFit: "contain"
            }}
          />
        )}
        <img
          src="/static/logos/gotyou.png"
          alt="Logo GotYou"
          style={{
            height: "auto",
            width: "100%",
            maxWidth: "45%",
            objectFit: "contain"
          }}
        />
      </div>

      <div
        className="card"
        style={{
          maxWidth: "600px",
          margin: "0 auto",
          padding: "20px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          fontSize: "14px"
        }}
      >
        <h2 style={{ marginBottom: "20px", fontSize: "18px", textAlign: "center" }}>
          Responder CheckPoint
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "120px auto",
            rowGap: "6px",
            columnGap: "12px",
            marginBottom: "20px"
          }}
        >
          <div style={{ textAlign: "right", fontWeight: "bold" }}>Curso:</div>
          <div>{nome_curso}</div>

          <div style={{ textAlign: "right", fontWeight: "bold" }}>Turma:</div>
          <div>{nome_turma}</div>

          <div style={{ textAlign: "right", fontWeight: "bold" }}>Disciplina:</div>
          <div>{nome_disciplina}</div>

          <div style={{ textAlign: "right", fontWeight: "bold" }}>Professor:</div>
          <div>{nome_professor}</div>

          <div style={{ textAlign: "right", fontWeight: "bold" }}>Sessão:</div>
          <div>{nome_sessao}</div>

          <div style={{ textAlign: "right", fontWeight: "bold" }}>Pergunta:</div>
          <div>{texto_checkpoint}</div>

          <div style={{ textAlign: "right", fontWeight: "bold" }}>Tempo:</div>
          <div>{tempo_resposta} min</div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label style={{ fontSize: "13px" }}>Seu Nome</label>
            <input
              type="text"
              className="form-control"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label style={{ fontSize: "13px" }}>Seu E-mail</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label style={{ fontSize: "13px" }}>Sua Resposta</label>
            <textarea
              className="form-control"
              rows="4"
              value={resposta}
              onChange={(e) => setResposta(e.target.value)}
            ></textarea>
          </div>

          {mensagem && <p className="text-success">{mensagem}</p>}
          {erro && <p className="text-danger">{erro}</p>}

          <button type="submit" className="btn btn-primary mt-2">
            Enviar Resposta
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResponderCheckpoint;

